const miscBucket = process.env.REACT_APP_MISC_BUCKET;

const resolveFileSrc = ({ fileName, customS3Bucket, folder }) => {
	const bucketLink = customS3Bucket || miscBucket;
	const folderPath = (folder || []).join('/');
	const linksArr = [bucketLink, folderPath, fileName].filter((v) => !!v);

	return linksArr.join('/');
};

export { resolveFileSrc };
